import React from "react";
import { ArrowRight, MessageCircle, Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/lib/contact";

export default function FinalCta() {
  const { t, lang } = useLang();
  const f = t.finalCta;
  const waMessage =
    lang === "de"
      ? "Hallo in7sekunden, ich interessiere mich für einen NFC-Aufsteller."
      : "Hi in7sekunden, I'm interested in an NFC stand.";

  return (
    <section className="section-y bg-white" data-testid="final-cta-section">
      <div className="container-x">
        <div className="relative rounded-[28px] bg-brand-ink text-white overflow-hidden grain">
          <div aria-hidden className="absolute inset-0 opacity-40 pointer-events-none">
            <div className="absolute -top-40 -right-40 w-[560px] h-[560px] rounded-full bg-brand-champagne/15 blur-3xl" />
            <div className="absolute -bottom-40 -left-40 w-[560px] h-[560px] rounded-full bg-brand-silver/10 blur-3xl" />
          </div>

          <div className="relative p-8 md:p-14 lg:p-20 grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <span className="overline !text-brand-champagne">{f.overline}</span>
              <h2 className="mt-5 text-3xl md:text-4xl lg:text-[44px] leading-tight font-semibold tracking-tight text-white text-balance">
                {f.title}
              </h2>
              <p className="mt-6 text-base md:text-lg text-white/70 leading-relaxed text-pretty max-w-xl">
                {f.body}
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <a href="/#contact" className="btn-on-dark" data-testid="finalcta-primary">
                  {f.cta1}
                  <ArrowRight className="h-4 w-4" />
                </a>
                <a
                  href={CONTACT.whatsappUrl(waMessage)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 text-white px-6 py-3.5 text-sm font-medium tracking-wide transition-all duration-300 hover:border-white hover:-translate-y-0.5"
                  data-testid="finalcta-whatsapp"
                >
                  <MessageCircle className="h-4 w-4" />
                  {f.cta2}
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <ul className="space-y-3">
                {f.points.map((p, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-4"
                    data-testid={`finalcta-point-${i}`}
                  >
                    <span className="mt-0.5 grid place-items-center h-6 w-6 rounded-full bg-brand-champagne text-brand-ink shrink-0">
                      <Check className="h-3.5 w-3.5" strokeWidth={3} />
                    </span>
                    <span className="text-sm text-white/85 leading-relaxed">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
